import React, { useEffect, useState } from "react";
import ReactMapGL from "react-map-gl";
import {
  Popup,
  NavigationControl,
  FullscreenControl,
  ScaleControl,
  GeolocateControl,
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import CityInfo from "./city-info";
import Pins from "./Pin";
import axios from "axios";

const geolocateStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  padding: "10px",
};

const fullscreenControlStyle = {
  position: "absolute",
  top: 36,
  left: 0,
  padding: "10px",
};

const navStyle = {
  position: "absolute",
  top: 72,
  left: 0,
  padding: "10px",
};

const scaleControlStyle = {
  position: "absolute",
  bottom: 36,
  left: 0,
  padding: "10px",
};

const MyMap = () => {
  const initState = {
    viewport: {
      width: window.innerWidth - 5,
      height: window.innerHeight - 5,
      latitude: 35.7,
      longitude: 139.705,
      zoom: 14,
    },
  };
  const [state, setState] = useState(initState);
  const [popup, setPopup] = useState(null);
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get("https://hackason-2020.herokuapp.com/map")
      .then(({ data }) => {
        let noNanArr = data.split("NaN");
        let noNan = noNanArr.join("0");
        // console.log(JSON.parse(noNan).places.map((i) => i.average));
        const abb = JSON.parse(noNan)
          .places.slice(0, 50)
          .map((i) => ({
            ...i,
            concentration: Math.ceil(Math.random() * 2000),
          }));
        setDatas(abb);
      })
      .catch((e) => {
        console.error(e);
        alert("取得できませんでした。。。");
        setError(e);
      });
  }, []);

  const _onClickMarker = (city) => {
    setPopup(city);
  };

  const _renderPopup = () => {
    return (
      popup && (
        <Popup
          tipSize={5}
          anchor="top"
          longitude={popup.lng}
          latitude={popup.lat}
          closeOnClick={false}
          onClose={() => setPopup(null)}
        >
          <CityInfo info={popup} />
        </Popup>
      )
    );
  };

  // if (error) {
  //   return <div>不具合</div>;
  // }

  return (
    <div style={{ overflow: "hidden" }}>
      <ReactMapGL
        style={{ border: "2px solid grey" }}
        {...state.viewport}
        onViewportChange={(viewport) => setState({ viewport })}
        mapStyle="mapbox://styles/mapbox/outdoors-v11"
      >
        <Pins data={datas} onClick={_onClickMarker} />

        {_renderPopup()}

        <div style={geolocateStyle}>
          <GeolocateControl />
        </div>
        <div style={fullscreenControlStyle}>
          <FullscreenControl />
        </div>
        <div style={navStyle}>
          <NavigationControl />
        </div>
        <div style={scaleControlStyle}>
          <ScaleControl />
        </div>
      </ReactMapGL>
    </div>
  );
};

export default MyMap;
